import { z } from 'zod';
import { DEFAULT_REPORT_ID, STATUTORY_REPORT_IDS } from './-constants';
export const ReportsSearchSchema = z.object({
  freeText: z.string().default(''),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(50),
  /** 表示中の法定帳票。未知の値は既定へフォールバックする */
  report: z.enum(STATUTORY_REPORT_IDS).catch(DEFAULT_REPORT_ID).default(DEFAULT_REPORT_ID)
});
export type ReportsSearchParams = z.infer<typeof ReportsSearchSchema>;